import { useState } from "react";
import { ValidationError, object, string } from "yup";
import { FormControl, Grid, Typography } from '@mui/material';
import { CommonButton, CommonOutlinedButton, CustomCheckbox, CustomInputLabel, CustomMenuItem, CustomRequiredInputLabel, CustomSelectforFamily, CustomTextFeildforFamily } from '../../common/StyledComponents/StyledFields';
import styles from '../reportSection.module.scss';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { apiRequest } from "../../../infrastructure/backendService";
import { ClipLoader } from "react-spinners";

const MailingLabelsReport = ({ sendDataToParent, getReportData }:any) => {

    const formFieldsMailingLabels = {
        alphabetSelected: "",
        zipCode: "",
    }

    interface ErrorMessageTypesMailingLabels {
        alphabetSelected: string,
    }

    const validationSchemaForpooja = object().shape({
        alphabetSelected: string().required('Last Letter is required')
    });

    const [errorMessageMailingLabels, setErrorMessageMailingLabels] = useState<ErrorMessageTypesMailingLabels>({ ...formFieldsMailingLabels });

    const [formDataMailingLabels, setFormDataMailingLabels] = useState(formFieldsMailingLabels);
    const errors: ErrorMessageTypesMailingLabels = {
        ...formFieldsMailingLabels
    };
    const [loading, setLoading] = useState(false);

    const [isMailLabelsSelected, setIsMailLabelsSelected] = useState(false);

    const alpha = Array.from(Array(26)).map((e, i) => i + 65);
    const alphabet = alpha.map((x) => String.fromCharCode(x));

    const handleDropdownChange = (field: any, value: any) => {
            setFormDataMailingLabels({
                ...formDataMailingLabels,
                [field]: value,
            });
    };

    const handleFieldChange = (field: any, value: any) => {
            setFormDataMailingLabels({
              ...formDataMailingLabels,
              [field]: value,
            });  
    };

    const getMailingLabelsReports = () => {
        const reqBody:any = {
            lastNameStartsWith: formDataMailingLabels.alphabetSelected,
            mailingLabelsWithoutEmailIds: isMailLabelsSelected
        };
        if(formDataMailingLabels.zipCode !== "") {
            reqBody.zipCode = formDataMailingLabels.zipCode;
        }
        setLoading(true);
        apiRequest({
            method: "POST",
            endpoint: '/report-dashboard/reports/devotee/MAILING_LABELS/browser',
            body: JSON.stringify(reqBody),
            includeToken:true
          })
         
          .then((res) => {
            setLoading(false);
            sendDataToParent(true);
            getReportData(res.data);
          })
          .catch((err) => {
            setLoading(false);
          })
    };

    const handleClear = () => {
        setFormDataMailingLabels(formFieldsMailingLabels)
    }

    const handlSubmitMailingLabelsReport = async () => {

        try {
            // Validate the form data against the validation schema
            await validationSchemaForpooja.validate(formDataMailingLabels, { abortEarly: false });
            // If validation passes, you can submit the form
            setErrorMessageMailingLabels(errors);
            // Call your API or perform other actions here
            // saveApiCall();
            getMailingLabelsReports();

        } catch (error) {
            // Handle validation errors

            if (error instanceof ValidationError) {
                error.inner.forEach((e) => {
                    if (e.path) {
                        errors[e.path as keyof ErrorMessageTypesMailingLabels] = e.message;
                    }
                });
            }
            setErrorMessageMailingLabels(errors);
        }
    }



    const AlphabetDropdown = (): React.ReactElement => {
        return (
            <>
                <FormControl
                    className={styles.moveToDropdown}
                >
                    <CustomSelectforFamily
                        IconComponent={KeyboardArrowDownIcon}
                        defaultValue=""
                        id="grouped-select"
                        value={formDataMailingLabels.alphabetSelected}
                        onChange={(e) => {
                            handleDropdownChange("alphabetSelected", e.target.value);
                            setErrorMessageMailingLabels({ ...errorMessageMailingLabels, alphabetSelected: '' });
                          }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    border: "1px solid #F05802",
                                    "& ul": {
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        overflowY: "auto",
                                        minHeight: "auto",
                                        maxHeight: "300px",
                                        "&::-webkit-scrollbar": {
                                            width: "8px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: "#F3C539",
                                            borderRadius: "6px",
                                        },
                                    },
                                },
                            },
                        }}
                    >
                        {alphabet.map((item: any, i: any) => (
                            <CustomMenuItem value={item} key={i}>
                                {item}
                            </CustomMenuItem>
                        ))}
                    </CustomSelectforFamily>
                </FormControl>
                {errorMessageMailingLabels.alphabetSelected && (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessageMailingLabels.alphabetSelected}
                    </Typography>
                )}
            </>
        );
    };

    return (
      <div>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid item xs={12} sm={4}>
            {CustomRequiredInputLabel("Last Name Starts with", true)}
            {AlphabetDropdown()}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginTop: "0px" }}>
          <Grid item xs={12} sm={4}>
            <CustomInputLabel>Zip Code</CustomInputLabel>
            <CustomTextFeildforFamily
              style={{ minWidth: "100%", borderRadius: "8px" }}
              fullWidth
              value={formDataMailingLabels.zipCode}
              onChange={(e) => {
                const inputValue = e.target.value;
                handleFieldChange("zipCode", inputValue);
              }}
              className={styles.dateFeild}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid item xs={12} sm={4}>
            <div className={styles.label}>
              <CustomCheckbox
                checked={isMailLabelsSelected}
                onChange={() => setIsMailLabelsSelected(!isMailLabelsSelected)}
              />
              <CustomInputLabel className={styles.chckboxTitle}>
                Mailing labels who do not have email ids
              </CustomInputLabel>
            </div>
          </Grid>
        </Grid>
        <Grid sx={{ mt: 3, display:"flex",gap:"16px" }}>

          <CommonButton
            sx={{ width: "fit-content", height: "38px" }}
            onClick={handlSubmitMailingLabelsReport}
            disabled={loading}
            id="submit"
          >
            {loading ? (
              <>
                <ClipLoader color="#fff" loading={loading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Submitting...
                </span>
              </>
            ) : (
              "Submit"
            )}
          </CommonButton>
          <CommonOutlinedButton onClick={handleClear}>
            Reset
          </CommonOutlinedButton>
        </Grid>
      </div>
    );
};

export default MailingLabelsReport;